<template>
  <h1 v-if="h1"
    class="title-section"
    :class="classes">
    <slot />
  </h1>
  <h2 v-else
    class="title-section"
    :class="classes">
    <slot />
  </h2>
</template>

<script>
import { computed, reactive } from "vue";

export default {
  name: "AppTitle",
  props: {
    h1: {
      type: Boolean,
      default: false,
    },
    to: {
      type: String,
      default: null,
    },
  },

  setup(props) {
    props = reactive(props);

    return {
      classes: computed(() => {
        const arr = []

        if (!props.h1) {
          arr.push('_small')
        }

        return arr.join(' ')
      }),
    };
  },
};
</script>

<style lang="scss" scoped>
.title-section {
  $that: &;

  color: #232930;
  font-weight: 700;
  // font-size: 40px;
  font-size: 80px;
  line-height: 120%;
  // line-height: 56px;

  &._small {
    font-size: 65px;

    @include tablet {
      font-size: 34px;
      line-height: 120%;
    }
  }

  @include laptop {
    font-size: 26px;
    line-height: 37px;
  }

  @include phone {
    font-size: 22px;
    line-height: 24px;
  }
}
</style>
